import React from 'react'

import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import MediaListItem from './MediaListItem'
import { MediaFileMetadata } from '@3m5/sm_publish-frontend-api'
import { ExtendedMediaFileMetadata } from './MediaGalleryComponent'

interface IProps {
  mediaData?: ExtendedMediaFileMetadata[]
  filtered?: boolean
  selected?: ExtendedMediaFileMetadata
  setSelected: (item: any, thumbnail: string | undefined) => void
  elementSize: number
  useRoundImageBorders?: boolean
  doNotShowAsSelected?: boolean
}

const MediaList: React.FC<IProps> = ({ setSelected, selected, mediaData, elementSize, useRoundImageBorders, doNotShowAsSelected }) => {
  const useStyles = makeStyles((theme: Theme) => ({
    uList: {
      display: 'flex',
      flexWrap: 'wrap',
      listStyleType: 'none',
      margin: 0,
      padding: 0,
    },
    roundBorder: {
      borderRadius: '50%',
    },
  }))

  const classes = useStyles()

  const handleClick = (item: ExtendedMediaFileMetadata, thumbnail: string | undefined) => {
    return selected && item.mediaFileId === selected.mediaFileId ? setSelected({}, undefined) : setSelected(item, thumbnail)
  }

  return (
    <>
      <ul className={classes.uList}>
        {mediaData && Array.isArray(mediaData) && mediaData.map((item: ExtendedMediaFileMetadata, index: number) => {
          return (
            <li key={index} className={useRoundImageBorders ? classes.roundBorder : undefined}>
              <MediaListItem handleClick={handleClick} item={item} selected={selected} width={elementSize} doNotShowAsSelected={doNotShowAsSelected} />
            </li>
          )
        })}
      </ul>
    </>
  )
}

export default MediaList
